import { useQuery } from "react-query";
import ShippingService from "../api/services/ShippingService";

interface IIssuancesPayload {
  recordSalesforceId: string;
  recordAccessKey: string;
  transactionId: string;
}

export const useIssuances = (recordSalesforceId: string, recordAccessKey: string, transactionId: string = "N/A") => {
  const { data, isLoading, isError, isFetching, refetch, error } = useQuery(
    [recordSalesforceId, recordAccessKey, transactionId],
    async () => await ShippingService.getIssuances({
      record_salesforce_id: recordSalesforceId,
      record_access_key: recordAccessKey,
      transaction_id: transactionId
    }),
    {
      enabled: false
    }
  );

  return {
    issuancesRecordData: data?.data?.record,
    issuancesIsLoading: isLoading,
    issuancesIsFetching: isFetching,
    issuancesError: error,
    isIssuancesError: isError,
    fetchIssuances: refetch
  }
}